<template>
  <div class="container">
    <GenericButton
      class="image-btn"
      :title="`${isTagged(drug) ? 'Remove' : 'Use'} ${drug}`"
      v-for="drug in Drugs"
      :key="drug"
      @mouseover="showInfo(drug)"
      :image-src="getDrugImage(drug)"
      :is-active="isTagged(drug)"
      @click="toggleDrug(drug)"
    />
  </div>
</template>
<script>
import { useStore } from 'vuex';
import GenericButton from '../shared/GenericButton.vue';
export default {
    name: 'Drugs',
    setup() {
        const store = useStore();
        const showInfo = (drug) => {
            store.dispatch('handleIncomingCommand', {
                command: 'updateInfoPanel',
                data: { category: 'Drugs', stat: drug }
            });
        };
        const isTagged = (drug) => {
            return store.state.build.Drugs[drug]?.tagged;
        };
        const getDrugImage = (drug) => {
            return require(`@/assets/img/drugs/${drug}.png`);
        };
        const toggleDrug = (drug) => {
            store.dispatch('handleIncomingCommand', {
                command: 'toggleDrug',
                data: { drug }
            });
        };
        return {
            state: store.state,
            Drugs: Object.keys(store.state.build.Drugs).slice(0, -1),
            isTagged,
            getDrugImage,
            toggleDrug,
            showInfo
        };
    },
    components: { GenericButton }
};
</script>
<style scoped>
.container {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  row-gap: 2px;
}
.image-btn {
  cursor: pointer;
  float: left;
  width: 47px;
  height: 34px;
  padding-left: 0px;
  padding-right: 0px;
  margin-right: 0px;
  margin-left: 0px;
}
.image-btn:focus {
  outline: none;
  box-shadow: none;
}
</style>